// extracted by mini-css-extract-plugin
export default {"imageWrapper":"uK-z","twoColumnImage":"vK-z"};